<app-breadcrumb [title]="title"></app-breadcrumb>

<div class="container-fluid my-5">
  <div class="row">
    <div class="col">
      <app-loader [show]="skeleton"></app-loader>
      <div [class.d-none]="skeleton">

        <form [formGroup]="profileContactForm" (ngSubmit)="save()">
          <input type="hidden" formControlName="userId">
          <input type="hidden" formControlName="isActive">
          <div class="border rounded p-3 mb-3">
            <div class="row">
              <div class="col-md-12">
                <div class="border-bottom mb-3">
                  <div class="font-weight-normal">
                    <h6 class="fw-bold">Present Address</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="presentAddress">Address</label>
                  <textarea MyInput formControlName="presentAddress" class="form-control form-control-sm"></textarea>
                  <my-error controlName="presentAddress" errorKey="required">Present Address is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="presentCity">Present City</label>
                  <input MyInput formControlName="presentCity" class="form-control form-control-sm" />
                  <my-error controlName="presentCity" errorKey="required">Present City is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="presentPincode">Pincode</label>
                  <input MyInput formControlName="presentPincode" class="form-control form-control-sm" />
                  <my-error controlName="presentPincode" errorKey="required">Present Pincode is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="presentStateId">State</label>
                  <select MyInput formControlName="presentStateId" class="form-select form-select-sm"
                    (change)="getPresentDistricts($event.target.value)">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of states" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="presentStateId" errorKey="required">Present State is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="presentDistrictId">District</label>
                  <select MyInput formControlName="presentDistrictId" class="form-select form-select-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of presentDistricts" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="presentDistrictId" errorKey="required">Present District is required.</my-error>
                </div>
              </div>
            </div>
          </div>

          <div class="border rounded p-3 mb-3">
            <div class="row">
              <div class="col-md-12">
                <div class="border-bottom mb-3">
                  <div class="font-weight-normal">
                    <h6 class="fw-bold">Permanent Address</h6>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isPermanentSame" class="form-check-input"
                    id="isPermanentSame">
                  <label class="form-label" for="isPermanentSame">Same as Present Address</label>
                </div>
                <my-error controlName="isPermanentSame" errorKey="required">Permanent Address is required.</my-error>
              </div>
            </div>

            <div class="row" [class.d-none]="profileContactForm.get('isPermanentSame').value">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="permanentAddress">Address</label>
                  <textarea MyInput formControlName="permanentAddress" class="form-control form-control-sm"></textarea>
                  <my-error controlName="permanentAddress" errorKey="required">Permanent Address is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="permanentCity">permanent City</label>
                  <input MyInput formControlName="permanentCity" class="form-control form-control-sm" />
                  <my-error controlName="permanentCity" errorKey="required">Permanent City is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="permanentPincode">Pincode</label>
                  <input MyInput formControlName="permanentPincode" class="form-control form-control-sm" />
                  <my-error controlName="permanentPincode" errorKey="required">Permanent Pincode is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="permanentStateId">State</label>
                  <select MyInput formControlName="permanentStateId" class="form-select form-select-sm"
                    (change)="getPermanentDistricts($event.target.value)">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of states" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="permanentStateId" errorKey="required">Permanent State is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="permanentDistrictId">District</label>
                  <select MyInput formControlName="permanentDistrictId" class="form-select form-select-sm">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of permanentDistricts" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="permanentDistrictId" errorKey="required">Permanent District is required.
                  </my-error>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <button class="btn btn-primary rounded-0 ml-auto mr-2" [disabled]="!profileContactForm.valid || loading"
              type="submit">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
              Submit
            </button>
            <a (click)="goBack()" class="btn btn-outline-primary">Cancel</a>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>